import { render, staticRenderFns } from "./LottieAnimation.vue?vue&type=template&id=8154fbde&scoped=true&"
import script from "./LottieAnimation.vue?vue&type=script&lang=js&"
export * from "./LottieAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LottieAnimation.vue?vue&type=style&index=0&id=8154fbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8154fbde",
  null
  
)

export default component.exports